import styled from '@emotion/styled'
import { Grid } from '@yuno/design-system-web'
import { getCurrencyByCode } from '../../utils/currency'
import { ConnectionCardError } from '../connection-card-error'
import ConnectionCurrencyCard from '../connection-currency-card'
import { utils } from './constants'
import { useTranslation } from 'react-i18next'

type ConnectionCurrenciesProps = {
  currencies: Array<string>
  showAllCurrencies: boolean
}

const Container = styled(Grid)`
  margin-top: 20px;
  margin-left: 20px;
`

const Item = styled(Grid)`
  margin: 0px 20px 20px 0px;
`

const ConnectionCurrencies = ({
  currencies,
  showAllCurrencies,
}: ConnectionCurrenciesProps) => {
  const { lastCurrencyPosition, maxCurrenciesVisible } = utils
  const { t } = useTranslation()
  currencies = showAllCurrencies
    ? currencies.slice(0, maxCurrenciesVisible)
    : currencies
  return currencies?.length ? (
    <Container container>
      {currencies?.map((countryCode, index) => {
        const showMore = showAllCurrencies && index === lastCurrencyPosition
        const _currency = getCurrencyByCode({ countryCode })
        if (Object.keys(_currency).length) {
          const title = showMore ? t('172-more') : _currency?.code
          const description = showMore ? t('currencies') : _currency?.name
          const icon = showMore ? 'Plus' : null
          return (
            <Item item key={index}>
              <ConnectionCurrencyCard
                title={title}
                description={description}
                symbol={_currency?.symbol}
                icon={icon}
              />
            </Item>
          )
        }
      })}
    </Container>
  ) : (
    <Grid container>
      <ConnectionCardError />
    </Grid>
  )
}

export default ConnectionCurrencies
